import { SubscriptionContract } from 'types/SubscriptionContract';

export const useTotalPrice = (subscription: SubscriptionContract) => {
  return subscription?.lines?.reduce((prev, item) => {
    return prev + parseFloat(item?.line_discounted_price?.amount);
  }, 0);
};
